export default "__VITE_ASSET__9YyQRfH$__"